export default "__VITE_ASSET__018fd67c__"